export default {
    methods: {
        handleUploadImage(file) {
            return new Promise((r, reject) => {
                // 检查文件类型和文件大小
                let file_size = false;
                let file_type = false;
                if (file.size > this.fileSize) {
                    file_size = true;
                } else if (!/image\/(\w+)/.test(file.type)) {
                    file_type = true;
                }

                if (file_type) {
                    reject('文件类型有误！');
                    this.$alert('文件类型有误！', {
                        title: '温馨提示',
                        customClass: 'alert',
                        confirmButtonText: '确定'
                    });
                }
                if (file_size) {
                    reject('文件大小过大！');
                    this.$alert('文件大小过大！', {
                        title: '温馨提示',
                        customClass: 'alert',
                        confirmButtonText: '确定'
                    });
                }
                if (!file_size && !file_type) {
                    this.uploadFile(file)
                        .then(url => {
                            // this.preview_template[ i ].list[ index ].image.url = url
                            // console.log(url)
                            r(url);
                        })
                        .catch(reject);
                }
            });
        }
    }
};
